import { c as _c } from "react/compiler-runtime";
import type { CompareHeaderCtaItemType } from '@/app/lcv/components/sections/compare/list/header-cta';
import { getCategoryNameTh } from '@/app/lcv/components/sections/compare/utils';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const CompareListHeadline = t0 => {
  const $ = _c(17);
  let category;
  let model;
  let rest;
  if ($[0] !== t0) {
    ({
      category,
      model,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = category;
    $[2] = model;
    $[3] = rest;
  } else {
    category = $[1];
    model = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("space-y-1 text-center");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createDataAttributes({
      test: "category"
    });
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== category) {
    t3 = getCategoryNameTh(category);
    $[6] = category;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <h2 className="text-body-1 font-noto-bold" {...t2}>{t3}</h2>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: "model"
    });
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== model.name) {
    t6 = <p className="text-body-2" {...t5}>{model.name}</p>;
    $[11] = model.name;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== rest || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className={t1} {...rest} role="cell">{t4}{t6}</div>;
    $[13] = rest;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};